import pic71 from './assets/images/71.jpg';
import pic72 from './assets/images/72.jpg';
import pic73 from './assets/images/73.jpg';
import pic77 from './assets/images/77.jpg';

import svg11 from './assets/svg/11.svg';
import svg61 from './assets/svg/61.svg';

const Seven = () => (
	  <section style={{paddingTop: "1em"}}>
		<div className="section-num" style={{top: 0}}>7</div>
		<p><img src={pic71} alt="" /></p>
		<div className="wrapper">
			<h2>Symboly našich kultur</h2>
			<p className="like-h3">Mnoho zemí má ve svých státních vlajkách a znacích strom. Jedná&nbsp;se&nbsp;o&nbsp;symboly vyjadřující obdiv ke&nbsp;krásám přírody i odkazy na uctívání stromů jako posvátných a magických přírodních chrámů.</p>
			<p className="txt-right">
				<span className="relative inline-block" style={{maxWidth: "12em"}}>Od roku 1848 je naším národním stromem lípa. Lipový odkaz najdeš na standartě prezidenta, státní pečeti, vojenských uniformách i&nbsp;bankovkách.
					<img src={svg11} className="pointer" style={{top: "90%", right: "55%", maxWidth: "28%"}} alt="" />
				</span>
			</p>
		</div>
		<p><img src={pic72} alt="" /></p>
		<div className="wrapper">
			<p style={{marginTop: "-1em"}}>
				<span className="relative inline-block" style={{maxWidth: "13em"}}>Lípa je od nepaměti symbolem ochrany a lásky. Dokáže prý odehnat zlé duchy. Lidé ji proto vysazovali u domů, kapliček a křížků.
					<img src={svg61} className="pointer" style={{bottom: "100%", right: "50%", maxWidth: "40%"}} alt="" />
				</span>
			</p>
			<h2>Stromy<br />jako chrámy</h2>
			<p className="like-h3">Stromy mají své nezastupitelné místo v&nbsp;mnoha lidových tradicích a mytologii po celém světě. U nás se dodnes staví na jaře májky, prastaré symboly lásky a&nbsp;strážci obcí.</p>
			<p className="txt-right">
				<span className="relative inline-block" style={{maxWidth: "15em"}}>Za posvátné stromy jsou odpradávna považovány duby. Symbolizují sílu, mohutnost a dlouhověkost. Slované i Keltové je respektovali jako ducha své komunity.
					<img src={svg11} className="pointer" style={{top: "110%", right: "55%", maxWidth: "20%"}} alt=""/>
				</span>
			</p>
		</div>
		<p><img src={pic73} alt="" /></p>
		<div className="wrapper">
			<p style={{maxWidth: "15.1em"}}><b className="tip">Tip pro tebe:</b> Obejmi dub, u kterého stojíš. Zkus chvíli odpočívat v jeho stínu. Možná ti poskytne důležitou radu nebo rozřešení problémů, tak jako našim předkům.</p>
			<h2>Stromy nás spojují</h2>
			<p className="like-h3">Významné a uctívané stromy byly součástí slavností, u kterých se&nbsp;scházela celá vesnice. Stejně jako se&nbsp;dnes my scházíme na náměstích při&nbsp;rozsvěcování vánočních stromů.</p>
			<p>
				<span className="relative inline-block" style={{maxWidth: "15em"}}>Velcí a staří stromoví mohykáni si nás k sobě magicky přitahují. Vůbec nejmohutnější strom v Česku je Vejdova lípa u Pastvin ve východních Čechách.
					<img src={svg11} className="pointer" style={{top: "110%", right: "55%", maxWidth: "20%"}} alt="" />
				</span>
			</p>
		</div>
		<p><img src={pic77} alt="" /></p>
		<div className="wrapper">
			<p className="txt-right" style={{marginTop: "-1em"}}>
				<span className="relative inline-block" style={{maxWidth: "13em"}}>Obvod jejího kmene činí přes 13 metrů. K jejímu společnému obejmutí se musí sejít alespoň 8 lidí.
					<img src={svg61} className="pointer" style={{bottom: "100%", right: "50%", maxWidth: "35%"}} alt="" />
				</span>
			</p>
		</div>
	</section>
);

export default Seven;
